import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PaymentOptions from '../PaymentOptions'
import PaymentButton from '../PaymentButton'
import currencyUtils from 'utils/currency'
import objectUtils from 'utils/object'
import * as actions from 'actions/index'
import Aux from 'hoc/ReactAux/ReactAux'

class CartInvoice extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cardSelected: null,
      payType: null,
      payWithAnotherCard: false,
    }
  }

  onHandleSelectPaymentMethod = (id, type) => {
    if (id === 'payWithAnotherCard') {
      this.setState({
        payType: 'C',
        cardSelected: null,
        payWithAnotherCard: true,
      })
    } else {
      let card = this.props.cards.find(item => {
        return (item.cardId === id)
      })

      this.setState({
        payType: 'C',
        cardSelected: card,
        payWithAnotherCard: false,
      })
    }
  }

  onHandlePlaceOrder = () => {
    console.log('onHandlePlaceOrder')
    this.props.toggleIsButtonDisabled(true)
    if (this.state.payType === 'C' && !this.state.payWithAnotherCard) {
      this.props.onHandlePayInvoice(this.getPayInfo(), this.props.history)
    } else if (this.state.payType === 'C' && !!this.state.payWithAnotherCard) {
      this.props.history.push("/Menu/checkout")
    }
  }

  getPayInfo = () => {
    
    return {
      idOrder: this.props.invoice.invoiceNumber,
      amount: this.props.invoice.total,
      currency: this.props.invoice.currency,
      payType: this.state.payType,
      paymentReference: objectUtils.get(this.state, 'cardSelected.cardId', undefined),
      idBusinessRestaurant: 0,
    }
  }

  render() {
    return (
      <Aux>
        <h2>Your Cart invoice </h2>
        <div className="items">
          <h3 className="product-cart-invoice-description">
            Invoice number : {this.props.invoice.invoiceNumber}
          </h3>
        </div>
        <div className="total-items">
          <div className="total">
            <div className="left">
              <p>Total</p>
            </div>
            <div className="right">{
              currencyUtils.convertNameToSymbol(this.props.invoice.currency) +
              this.props.invoice.total.toFixed(2)}
            </div>
          </div>
        </div>
        <PaymentOptions
          payTypeSelected={this.state.payType}
          cardSelected={this.state.cardSelected}
          selectPaymentMethod={this.onHandleSelectPaymentMethod}
          total={this.props.invoice.total}
          subsidy={0}
          business={0}
          cards={this.props.cards} />
        <PaymentButton
          buttonText={'Pay invoice'}
          payTypeSelected={this.state.payType}
          campaignRateCC={null}
          disabled={this.props.isButtonDisabled}
          handlePlaceOrder={this.onHandlePlaceOrder} />
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    business: state.businessReducer.business,
    cards: state.cartReducer.cart.cards,
    invoice: state.invoiceReducer.invoice
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onToggleCart: () => dispatch(actions.toggleCart()),
    toggleIsButtonDisabled: (disabled) => dispatch(actions.toggleIsButtonDisabled(disabled)),
    onHandlePayInvoice: (payload, history) => dispatch(actions.handlePayInvoice(payload, history))
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(CartInvoice))



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/CartInvoice/index.js